// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Mr-z","badgeLink":"Nr-z","category":"Or-z"};